import React, { useEffect, useCallback, useRef } from 'react';
import { createPortal } from 'react-dom';

import useTranslate from '../../../../common/hooks/useTranslate';
import useClickOutside from '../../../../common/hooks/useClickOutside';
import { useSelector, useDispatch } from 'react-redux';

import { RootState } from '../../../../redux/store';
import { MODAL } from '../../../../redux/types';

import Icon from '../../icon/icon';

import './actionForbidden.scss';

const modalElement = document.getElementById('modal-root');

export const ActionForbidden: React.FC = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const modalRef = useRef(null);

  const showModal = useSelector((state: RootState) => state.impersonateModeModal.showModal);

  const close = () => {
    dispatch({ type: MODAL.SWITCH_IMPERSONATE_MODE_MODAL });
  };

  const handleEscape = useCallback(
    (event) => {
      if (event.keyCode === 27) close();
    },
    [close],
  );

  useEffect(() => {
    if (showModal) document.addEventListener('keydown', handleEscape, false);
    return () => {
      document.removeEventListener('keydown', handleEscape, false);
    };
  }, [handleEscape, showModal]);

  useClickOutside(modalRef, close);

  return createPortal(
    showModal ? (
      <div className={`modal`}>
        <div className='modal-body' ref={modalRef}>
          <div className={'modal-title'}>
            <Icon name='fas fa-xmark' className='impersonate-off-icon pointer' onClick={close} />
          </div>
          <Icon name={'fas fa-masks-theater'} className='impersonate-icon' />
          <h1>{t('ACTION_FORBIDDEN.TEXT1')}</h1>
          <h2>{t('ACTION_FORBIDDEN.TEXT2')}</h2>
        </div>
      </div>
    ) : null,
    modalElement,
  );
};

export default ActionForbidden;
